import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=6fb3dfcb&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens-v2.vue?vue&type=style&index=0&id=6fb3dfcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3dfcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb3dfcb')) {
      api.createRecord('6fb3dfcb', component.options)
    } else {
      api.reload('6fb3dfcb', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=6fb3dfcb&scoped=true&", function () {
      api.rerender('6fb3dfcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dM0N2CKKLRo0/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports